import { Link } from "react-router-dom";

export const NoData = ({ title, desc, url, className }) => {
  return (
    <div className={`NoDataContainer p-tb-4 ${className}`}>
      <div className="inner">
        <div>
          <p className="title">{title} 목록이 없어요😅</p>
          <p className="desc">{desc}</p>
          <Link className="btn" to={url}>
            바로가기
          </Link>
        </div>
      </div>
    </div>
  );
};
